module.exports = __webpack_public_path__ + "static/media/NotoSansKR-Light.89816c0e.ttf";